export default "__VITE_ASSET__DeJIorNK__"